import {
  RFID_FILE_UPLOAD_REQUEST,
  RFID_FILE_UPLOAD_SUCCESS,
  RFID_FILE_UPLOAD_FAILURE, RFID_FILE_UPLOAD_SET_SUBMITTED,
} from '../actions/types/RfidUploadActionsTypes';

export const initialState = {
  submitted: false,
  submitting: false,
  validation: {
    file: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RFID_FILE_UPLOAD_SET_SUBMITTED:
      return {
        ...state,
        submitted: action.submitted,
      };
    case RFID_FILE_UPLOAD_REQUEST:
      return {
        ...state,
        submitting: true,
      };
    case RFID_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        validation: {
          file: '',
        },
      };
    case RFID_FILE_UPLOAD_FAILURE: {
      const { payload: { validation } } = action;
      return {
        ...state,
        submitting: false,
        validation: validation ? {
          ...state.validation,
          ...validation,
        } : state.validation,
      };
    }
    default:
      return state;
  }
};
